/**
 * Which nav item `/` renders — shared by `routes/index.tsx` (HomePage)
 * and `ordo-sidebar.tsx` (active-highlight) so the two can never drift.
 *
 * Preference order:
 *   1. first non-priority item that isn't `settings` (persona work page);
 *   2. first non-settings item of any zone (a cafeteria worker's only
 *      items are Tasks [priority] + Settings — Tasks must win, Settings
 *      is never a home);
 *   3. the first item as a last resort (settings-only nav).
 *
 * Generic over the minimal `{ zone, slug }` shape so both the client's
 * `ProfileNavItem` and unit-test literals fit. Pure — unit-tested.
 */
export function pickHomeNavItem<T extends { zone: string; slug: string }>(items: ReadonlyArray<T>): T | null {
  return (
    items.find((it) => it.zone !== 'priority' && it.slug !== 'settings') ??
    items.find((it) => it.slug !== 'settings') ??
    items[0] ??
    null
  )
}
